import { NavLink, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { allowedSettingsTabs } from '../features/settings/settingsTabs';
import '../features/settings/settings.css';

/**
 * 系统设置页 —— 框架容器（P4.2）。
 *
 * 布局：左侧四个标签（按权限过滤，无权限的不渲染）+ 右侧内容区（子路由 Outlet）。
 *   /settings/users           用户管理    user:manage
 *   /settings/roles           权限配置    role:manage
 *   /settings/project-types   项目类型    dict:manage
 *   /settings/task-categories 任务形态    dict:manage
 *
 * ⚠️ 能力兜底：一个 system 权限都没有时，只显示「无权限访问系统设置」，
 *    不渲染空标签栏（不是重定向，便于用户理解）。
 */
export default function SystemSettingsPage() {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const tabs = allowedSettingsTabs(hasPermission);

  return (
    <div className="page">
      <div className="page__head">
        <h1 className="page__title">系统设置</h1>
        <div className="page__sub">平台参数 · 权限 · 元数据配置</div>
      </div>

      {tabs.length === 0 ? (
        <div className="placeholder">
          <div className="ph__icon">⊘</div>
          <div className="ph__t">无权限访问系统设置</div>
          <div className="ph__h">
            当前账号没有任何系统设置管理权限，请联系管理员分配后再访问。
          </div>
        </div>
      ) : (
        <div className="settings">
          <nav className="settings__side" aria-label="系统设置导航">
            <div className="settings__side-label">配置项</div>
            {tabs.map((tab) => (
              <NavLink
                key={tab.key}
                to={tab.to}
                className={({ isActive }) =>
                  ['settings__tab', isActive ? 'on' : ''].join(' ')
                }
              >
                <span className="settings__tab-icon">{tab.icon}</span>
                <span className="settings__tab-label">{tab.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="settings__content">
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
}
